export default __webpack_public_path__ + "static/media/World.9d259114.png";